import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
  DineinTableLabelContext,
  resolveDineinTableLabel,
} from "./dinein-table-label.helpers";

@Pipe({
  name: "dineinTableLabel",
})
export class DineinTableLabelPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  // The pipe stays pure. `DineinTableLabelService` emits a NEW context object
  // whenever the configured word or the selected language changes, so the
  // reference change is what re-runs it - the language matters even when the
  // word itself is identical across languages, because the sentence around it
  // is not.
  transform(
    defaultKey: string,
    context?: DineinTableLabelContext
  ): string {
    // `true` = render "" while the locale file is still in flight, which is what
    // the `| translate` pipe these call sites replaced did.
    return resolveDineinTableLabel(
      this.translateService,
      defaultKey,
      context && context.word,
      true
    );
  }
}
